import React from 'react';
import { Avatar, Fade } from '@mui/material';
import { Box } from '@mui/system';
import { getFile } from '../api/bot';

const TableAvatar = ({ uuid, type, sx, variant, alt }) => {
  return (
    <Box sx={{ ...sx, position: 'relative' }}>
      <Fade in={!!uuid}>
        <Avatar
          src={getFile({ [type]: uuid })}
          variant={variant || 'circular'}
          alt={alt || ''}
          sx={{ m: 'auto' }}
        />
      </Fade>
    </Box>
  );
};

export default TableAvatar;
